<button
  class="btn btn-back ms-5 pt-5 mb-5"
  (click)="backToHomepage()"
  [disabled]="loading"
  style="max-width: 200px; text-align: left"
  >
  <fa-icon [icon]="faChevronLeft"></fa-icon>
  <span
    class="ms-2"
    style="font-size: 0.9rem; font-weight: 500; text-transform: none"
    >
    {{ "actions.homepage" | translate }}
  </span>
</button>

<div class="ms-5">
  <div class="d-flex flex-row">
    <h1 class="title" translate>change-psw.title</h1>
  </div>
</div>

<div class="card full-card shadow-sm m-4 card-v-center ms-5 me-5">
  <div class="card-body">
    <form [formGroup]="form" class="form-horizontal">
      <div class="d-flex flex-row flex-wrap">
        <div class="col-12 p-0">
          <div class="form-group form-input-group form-inline row my-4">
            <app-label
              class="form-input-label col-md-3"
              text="{{'login.field.old-password' | translate}}"
              id="oldPasswordLabel"
              [html]="true"
              tooltip="tooltip.change-password.old-password"
              >
            </app-label>
            <div class="col-md-9">
              <input
                type="password"
                class="form-control form-input input-with-border"
                formControlName="oldPassword"
                id="oldPassword"
                name="oldPassword"
                [disabled]="loading"
                [ngClass]="{ 'is-invalid': submitted && f.oldPassword.errors }"
                required
                />
              @if (f.oldPassword.errors !== null) {
                <div
                  class="invalid-feedback mt-2"
                  >
                  @if (f.oldPassword.errors.required) {
                    <div translate>
                      generic.message.validation.mandatory-error
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          <div class="form-group form-input-group form-inline row my-4">
            <app-label
              class="form-input-label col-md-3"
              text="login.field.newPassword"
              id="passwordLabel"
              [html]="true"
              tooltip="tooltip.change-password.password"
              tooltipClass="ps-2 ms-0 text-start"
              >
            </app-label>
            <div class="col-md-9">
              <input
                type="password"
                class="form-control form-input input-with-border"
                formControlName="password"
                id="password"
                name="password"
                [disabled]="loading"
                [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                required
                />
              @if (f.password.value !== '') {
                <div class="my-2">
                  <pwc-password-meter
                    [password]="f.password.value"
                  ></pwc-password-meter>
                </div>
              }
              @if (f.password.errors !== null) {
                <div
                  class="invalid-feedback mt-2"
                  >
                  @if (f.password.errors.required) {
                    <div translate>
                      generic.message.validation.mandatory-error
                    </div>
                  }
                  @if (
                    f.password.errors.minlength && !f.password.errors.required
                    ) {
                    <div
                      translate
                      >
                      generic.message.validation.password-min-length
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          <div class="form-group form-input-group form-inline row my-4">
            <app-label
              class="form-input-label col-md-3"
              text="login.field.newPasswordConfirm"
              id="confirmPasswordLabel"
              [html]="true"
              tooltip="tooltip.signup.confirmPassword"
              >
            </app-label>
            <div class="col-md-9">
              <input
                type="password"
                class="form-control form-input input-with-border"
                formControlName="confirmPassword"
                [disabled]="loading"
                [ngClass]="{
                  'is-invalid': submitted && f.confirmPassword.errors,
                }"
                id="confirmPassword"
                name="confirmPassword"
                required
                />
              @if (f.confirmPassword.errors || f.password.errors) {
                <div
                  class="invalid-feedback mt-2"
                  >
                  @if (
                    f.password.errors &&
                    f.password.errors.required &&
                    !(
                    f.confirmPassword.errors &&
                    f.confirmPassword.errors.mustMatch
                    )
                    ) {
                    <div
                      translate
                      >
                      generic.message.validation.mandatory-error
                    </div>
                  }
                  @if (
                    f.confirmPassword.errors &&
                    f.confirmPassword.errors.mustMatch
                    ) {
                    <div
                      translate
                      >
                      generic.message.validation.password-confirm-check
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="col-12 p-0 mt-4">
          <section>
            <div class="row">
              <div class="col">
                <div class="d-flex flex-row px-0 py-1">
                  <button
                    class="btn btn-primary btn-rounded ms-auto"
                    (click)="onSave()"
                    [disabled]="loading || form.invalid"
                    style="max-width: 300px"
                    >
                    <span
                      style="
                        max-width: 300px;
                        font-size: 0.8rem;
                        font-weight: 500;
                      "
                      >
                      {{ "actions.change-password" | translate }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </form>
  </div>
</div>
